$.fn.SelectedAnchor = function() {
  let self = this
  self.current_anchor = false

  self.scroll = function() {
    let anchors = $('.page-template__content').find('h1[id], h2[id], h3[id], h4[id], h5[id], h6[id]').get().reverse()
    for (let i = 0; i < anchors.length; i++) {
      let el = anchors[i]
      let offset = $(el).offset().top - $(window).scrollTop() - $('.header').outerHeight() - (window.innerHeight / 2)
      if (offset < 0) {
        let new_anchor = $(el).attr('id')
        if (new_anchor !== self.current_anchor) {
          self.find('a').removeClass('--selected')
          self.find('a[href="#' + new_anchor + '"]').addClass('--selected')
          self.current_anchor = new_anchor
        }
        break
      }
    }
  }

  return function() {
    $(window).scroll(self.scroll)
    return self
  }()
}
